module.exports = __webpack_public_path__ + "static/media/shopify.2be67dd3.png";